import { render, staticRenderFns } from "./NotificationMenuItem.vue?vue&type=template&id=1044489c"
import script from "./NotificationMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationMenuItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports